import { Button } from 'antd';
import React from 'react';
import BottomBox from 'components/BottomBox';
import { useAlertModal } from 'components/Modal';
import { printf } from 'utils/i18n';
import completeImg from './images/deposit-complete.jpg';
import './style.scss';

interface NativeProps {
    amount: string;
    onConfirm: () => void;
}

const Native: React.FC<NativeProps> = ({ amount, onConfirm }) => {
    const { open: openAlertModal } = useAlertModal();

    const openPolicyModal = () => {
        return openAlertModal({
            className: 'deposit-policy-modal',
            centered: true,
            content: (
                <section>
                    <p>
                        {__(
                            'You may receive instant funds for your immediate trading. It may take up to 5 business days for the full amount to be cleared, depending on the bank you are using.'
                        )}
                    </p>
                    <p>
                        {__(
                            'Please make sure you have maintained sufficient amount in your bank account to avoid a transfer reversal. ACH reversals may result in fees assessed to your account.'
                        )}
                    </p>
                    <p>
                        {__(
                            'If you are using your savings account, please be advised that your financial institutions may have limitations on the number of transactions per month that can be made.'
                        )}
                    </p>
                </section>
            ),
            okText: __('Done')
        });
    };

    return (
        <div className="deposit-native-ach-complete-root">
            <img className="success-img" src={completeImg} alt="" />
            <span className="deposit-success-star">{__('Congratulations')}</span>
            <p className="desc">
                {printf(
                    __(
                        'We have received your %s deposit request! While your deposit is on its way, you can begin investing with the instant funding we have granted in your account.'
                    ),
                    amount || 0
                )}
            </p>
            <p className="desc">
                {__('Once your deposit settles, those instant funds will no longer be available in your account.')}
            </p>
            <BottomBox>
                <Button type="primary" className="status-btn" onClick={onConfirm}>
                    {__('Done')}
                </Button>
                <div className="policy" onClick={openPolicyModal}>
                    <span>{__('Deposit and instant funding policy')}</span>
                </div>
            </BottomBox>
        </div>
    );
};

export default Native;
